import TouristPlaces from "../components/Venue/TouristPlaces";

export default function Tourism() {
    return(
        <main className=" mt-28">
            <TouristPlaces />
        </main>
    )
}